import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/sa/custom-software/grow.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{
        backgroundImage: `url(${BannerImg})`,
        backgroundPosition: "left",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Grow Your Digital Presence with Our Custom Software Development
            </h2>
            <p>
              We're recognized as one of the premier software companies in
              Riyadh, delivering customized solutions to help your business stay
              competitive in the industry. Our software engineers assist you in
              creating a scalable and differentiated brand presence.
            </p>
            <p>
              TekRevol worked with over 500 firms in the last few years,
              including Fortune 500 corporations, which provides our software
              development company Saudi Arabia team the confidence to take on
              larger challenges and continue the legacy of building powerful
              software solutions. We turn ideas into successful digital
              solutions through a structured process, creating high-revenue
              outcomes for your business. Our precision and innovation guarantee
              tangible results.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start Your Project With Us!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
